import store from 'store2'
import { cutlassEvent } from '@polleverywhere/cutlass'

function fetchCustomerExperience (login) {
  return Backbone.ajax({
    url: `/api/customer_experience/segments/${login}`,
    dataType: 'json'
  })
}

async function handleActivityResult (app, presenterLogin) {
  if (!presenterLogin) return

  try {
    const data = await fetchCustomerExperience(presenterLogin)
    // Persist the show_become_presener_cta if it ever true
    if (data.show_become_presenter) {
      store.set('show_become_presener_cta', true)
      // Match the event 'path' the homepage 'become-presenter' event has
      cutlassEvent(app.el, 'home:cta:become-presenter:set')
    }
  } catch (_) {}
}

/**
 * Query server for custom user experiences depending on the state
 */
export default (app) => {
  const dispatcher = _.clone(Backbone.Events)
  dispatcher.listenTo(app, 'reset:state', (state) => {
    if (state.get('role') !== 'participant') return
    dispatcher.listenTo(state, 'change:activePresenter', () => {
      handleActivityResult(app, state?.get('activePresenter')?.get('login'))
    })
  })
}
